import type { PropsWithChildren } from "react";

export const Form = ({ children }: PropsWithChildren<unknown>) => (
  <div className="size-full px-16 py-12">{children}</div>
);
